import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';
import dayjs from 'dayjs';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { addPayment, getPayment } from 'src/api/payment';
import { commonReducerAction } from 'src/redux/reducers/common';
import { paymentReducerAction } from 'src/redux/reducers/payment';
import PaymentForm from 'src/components/payments/PaymentFrom';

const AddPayment = () => {
  const location = useLocation();
  const member_id = location?.pathname?.split('/')?.pop();
  const date = dayjs().format('YYYY-MM-DD');
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { logoutUser } = commonReducerAction;
  const { updatePayments } = paymentReducerAction;
  const { user } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const navigate = useNavigate();
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Helmet>
        <title>Payment | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '2rem'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              amount: '',
              payment_for_this_month: dayjs(date).valueOf(),
              payment_received_on: '',
              mode_of_payment: 0
            }}
            validationSchema={CONSTANTS.registerPaymentScheme}
            onSubmit={async (values) => {
              const result = {
                member_id: member_id,
                amount: values.amount,
                date: dayjs(values.payment_received_on).valueOf(),
                payment_month_year: dayjs(values.payment_for_this_month).format(
                  'MM-YYYY'
                ),
                mode_of_payment: values.mode_of_payment
              };

              try {
                dispatch(startLoading());
                const res = await addPayment(user, result);
                dispatch(stopLoading());
                const isError = res.status !== 200;
                const message = isError ? res?.message : "Payment Added Successfully"
                setSnackbarState({
                  open: true,
                  message: message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  getPayment(user, member_id)
                    .then((res) => {
                      if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
                        dispatch(logoutUser());
                      if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
                        dispatch(updatePayments(res.data));
                      }
                      dispatch(stopLoading());
                      navigate(
                        CONSTANTS.ROUTES.PRIVATE_ROUTES.PAYMENT +
                          '/' +
                          member_id
                      );
                    })
                    .catch((err) => {
                      dispatch(stopLoading());
                      console.log(err);
                    });
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <PaymentForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                heading={STRINGS.ADD_PAYMENT}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Box>
    </>
  );
};

export default AddPayment;
